
import React from 'react';
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Control } from "react-hook-form";

interface QuoteAmountFieldProps {
  control: Control<any>;
  isLoading: boolean;
}

const QuoteAmountField: React.FC<QuoteAmountFieldProps> = ({
  control,
  isLoading
}) => {
  return (
    <FormField
      control={control}
      name="quotedAmount"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Quoted Amount</FormLabel>
          <FormControl>
            <Input placeholder="Enter amount" {...field} disabled={isLoading} />
          </FormControl>
          <FormDescription>
            Enter the amount quoted for this booking.
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default QuoteAmountField;
